import { deleteReq, post } from "../../service/api";

const DeleteVatMerchant = async (merchantId,vatMerchantId) => {
    try {
        const response = await deleteReq(`/merchant/${merchantId}/vatMerchant/${vatMerchantId}`);
        return response.data;
    } catch (error) {
        console.error('Error DeleteVatMerchant:', error);
        throw error;
    }
};

export default DeleteVatMerchant;